import React__default, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext(undefined);
const LanguageProvider = ({ children, translations, defaultLanguage = 'en', }) => {
    const [language, setLanguage] = useState(defaultLanguage);
    return (React__default.createElement(LanguageContext.Provider, { value: { language, setLanguage, translations } }, children));
};
const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (context === undefined) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
/*

export type LanguageType = "en" | "de" | "es";
  
interface LanguageContextType<T> {
  language: LanguageType;
  setLanguage: (Language: LanguageType) => void;
  translations: T;
};
  
const LanguageContext = createContext<LanguageContextType<any> | undefined>(undefined);
  
interface LanguageProviderProps<T> {
  translations: T;
  children: React.ReactNode;
  defaultLanguage?: LanguageType;
}
  
export const LanguageProvider: React.FC<LanguageProviderProps<any>> = ({
  children,
  translations,
  defaultLanguage = "en",
}) => {
  const [language, setLanguage] = useState<LanguageType>(defaultLanguage);
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
};
  
export const useLanguage = <T,>() => {
  const context = useContext<LanguageContextType<T> | undefined>(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
 */

export { LanguageProvider, useLanguage };
//# sourceMappingURL=LanguageProvider.js.map
